// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wMvG","type":"styles_type__3B9jb","choices":"styles_choices__1cA48"};